import { InvitationScreen } from "@hakili/app-shell";

/**
 * `P0-DLW-002`: dealer-web's mount of the shared acceptance screen.
 *
 * **It is a mount and not a screen.** `00-SPINE` 6.3 puts the screen itself in
 * `@hakili/app-shell` so that three apps cannot get the API's password rules
 * subtly different; what belongs to an app is where the accepted invitee LANDS,
 * and that is the callback `App` supplies.
 */
export function Invitation(props: {
  readonly token: string;
  readonly origin: string;
  readonly fetchImpl?: typeof globalThis.fetch;
  readonly onAccepted: (accessToken: string) => void;
}): React.JSX.Element {
  return <InvitationScreen {...props} />;
}
